import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './DetailItem.scss';
var DetailItem = function (_a) {
    var name = _a.name, value = _a.value, _b = _a.transPrefix, transPrefix = _b === void 0 ? '' : _b;
    var t = useTranslation().t;
    if (!value) {
        return null;
    }
    // there are a metric ton of exif keys, so for sake of
    // sanity anything untranslated should just show the raw key name
    var translatedKey = t("deviation.details." + transPrefix + name.replace(' ', ''), {
        defaultValue: name,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("dd", { className: s['detail-key'] }, translatedKey),
        React.createElement("dt", { className: s['detail-value'] }, value)));
};
DetailItem.displayName = 'DetailItem';
export default DetailItem;
//# sourceMappingURL=DetailItem.js.map